import React from "react";
import { motion } from "framer-motion";
import { FaChurch, FaUtensils, FaMapMarkerAlt } from "react-icons/fa";
import "./Locations.css";

const Locations = () => {
  const locations = [
    {
      name: "Åsane gamle kirke",
      address: "Saurås i Åsane, Bergen",
      description:
        "Vielsen vil finne sted i den historiske Åsane gamle kirke fra 1795, en vakker steinkirke med rik historie.",
      time: "12:30",
      dressCode: "Pent Antrekk / Dress",
      icon: FaChurch,
      mapUrl: "https://maps.google.com/?q=Åsane+gamle+kirke+Bergen",
    },
    {
      name: "Musikkhallen på Holme",
      address: "Melandsvegen 50, 5919 Frekhaug",
      description:
        "Velkomstdrink, middag og fest vil finne sted på Musikkhallen, en flott lokalitet for feiring og dans.",
      time: "14:30",
      dressCode: "Pent Antrekk / Dress",
      icon: FaUtensils,
      mapUrl: "https://maps.google.com/?q=Musikkhallen+på+Holme+Frekhaug",
    },
  ];

  return (
    <section id="locations" className="locations section">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Lokasjoner
        </motion.h2>

        <div className="location-cards">
          {locations.map((location, index) => (
            <motion.div
              key={index}
              className="location-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="location-icon">
                <location.icon />
              </div>

              <h3>{location.name}</h3>
              <p className="location-address">{location.address}</p>
              <p className="location-description">{location.description}</p>

              <div className="location-details">
                <p>
                  <strong>Tid:</strong> {location.time}
                </p>
                <p>
                  <strong>Antrekk:</strong> {location.dressCode}
                </p>
              </div>

              <a
                href={location.mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="location-map-btn"
              >
                <FaMapMarkerAlt />
                Se på kart
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
